
















import { Component, Prop, Vue } from "vue-property-decorator";

import { Dictionary } from "@/lib/Dictionary.type";

import FactoryEditForm from "./FactoryEditForm.vue";

@Component({
  metaInfo() {
    return {
      title: "Add Factory",
    };
  },
  components: {
    FactoryEditForm,
  },
})
export default class FactoryAddPage extends Vue {
  @Prop()
  public readonly listQuery?: Dictionary<string[]>;

  public onCancel(): void {
    void this.$router.push({
      name: "FactoriesListPage",
      query: this.listQuery,
    });
  }

  public onSuccess(): void {
    void this.$router.push({
      name: "FactoriesListPage",
      query: this.listQuery,
    });
  }
}
